import styled from "styled-components";
export const InstallmentSelectorContainer = styled.section`
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  padding: 32px;
  margin-bottom: 32px;
  .item {
    background-color: #f5f3f3;
    border: solid 1px #f5f3f3;
    margin: 4px 0;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    .title-area {
      display: flex;
      align-items: center;
      .color {
        margin-left: 16px;
        width: 32px;
        height: 32px;
        border-radius: 42px;
        box-shadow: 0 0 5px rgb(0 0 0 / 20%);
        display: inline-block;
      }
    }
    &:hover {
      border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    }
  }
  .selected {
    border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    background-color: #FFE2E2;
  }
  .notice {
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.lightFont};
    margin-top: 16px;
  }
  @media only screen and (max-width: 760px) {
    padding: 16px 8px;
  }
`;
